import React from "react";
import ProductBanner from "./components/product-banner";
import { INVOICE_FINANCING_INFO, PRODUCTS } from "../../constants/products";
import ProductBenefit, {
  ProductBenefitContent,
} from "./components/product-benefit";
import lowInterestIcon from "../../assets/images/products/low-interest.png";
import instantPayIcon from "../../assets/images/products/instant-pay.png";
import transparantIcon from "../../assets/images/products/transparancy.png";
import { Container } from "react-bootstrap";
import ProductClosingStatement from "./components/product-closing-statement";
import ProductHow, { ProductHowContent } from "./components/product-how";
import ProductPartner from "./components/product-partner";
import CheckCompany from "./components/check-company";
import RequiredDocuments from "./components/required-documents";
import ProductWorkingCapitalSimulation from "./components/product-working-capital-simulation";


const CONTENTS: ProductBenefitContent[] = [
  {
    title: "Bebas Biaya",
    image: transparantIcon,
    description: `Tidak ada biaya administrasi dan provisi di awal.`,
  },
  {
    title: "Pencairan Cepat",
    image: instantPayIcon,
    description:
      "Dana diterima dalam waktu maksimal 3 jam setelah invoice diterima.",
  },
  {
    title: "Bunga Rendah",
    image: lowInterestIcon,
    description: `Bunga antara ${Intl.NumberFormat("id-ID").format(INVOICE_FINANCING_INFO.interestRate.start)} - ${Intl.NumberFormat("id-ID").format(INVOICE_FINANCING_INFO.interestRate.end)}% per bulan, dengan tenor maksimal 12 bulan.`,
  },
];
const partner = {
  title1: "Perusahaan yang telah menggunakan",
  title2: "Invoice Financing",
  titleDescription: "",
  product: "invoice-financing",
  description: "",
};

function InvoiceFinancing() {
  const product = PRODUCTS.invoiceFinancing;
  const CONTENT_HOW: ProductHowContent[] = [
    {
      title: "Pendaftaran",
      description: (
        <React.Fragment>
          Pendaftaran dilakukan secara mandiri dengan mengklik{" "}
          <a href={product.link} target="_blank" rel="noreferrer">
            registrasi/daftar
          </a>{" "}
          serta melengkapi dokumen yang dipersyaratkan.
        </React.Fragment>
      ),
    },
    {
      title: "Proses Pengajuan dan Verifikasi",
      description: (
        <React.Fragment>
          Ajukan pinjaman dengam melampirkan dokumen yang dipersyaratkan. Tim
          Pohon Dana akan melakukan verifikasi data serta analisa secara
          menyeluruh.
        </React.Fragment>
      ),
    },
    {
      title: "Persetujuan",
      description: (
        <React.Fragment>
          Calon peminjam akan mendapatkan rekomendasi pengajuan pinjaman dan
          berhak untuk menyetujui atau menolak rekomendasi tersebut. Apabila
          menerima, peminjam wajib menandatangani perjanjian secara elektronik.
        </React.Fragment>
      ),
    },
    {
      title: "Proses Pencairan",
      description: (
        <React.Fragment>
          Setelah penandatanganan, pinjaman akan diteruskan kepada pihak pemberi
          dana untuk proses pencairan dana. Proses pencairan akan dilakukan
          dalam waktu 1 x 24 jam.
        </React.Fragment>
      ),
    },
  ];

  return (
    <div className="main-container" id="product-page">
      <ProductBanner product={product} />
      <Container className="my-5">
        <ProductBenefit
          title={
            <React.Fragment>
              <span className="text-primary-main">Keuntungan</span>{" "}
              {product.title}
            </React.Fragment>
          }
          contents={CONTENTS}
        />
        <div className="mt-4 text-secondary text-size-label text-center">
          Biaya Keterlambatan - 1,5% per bulan (pro rata)
        </div>

        <div className="mt-5 pt-5">
          <ProductHow
            marginBottom={2}
            product={product}
            contents={CONTENT_HOW}
            additionalTitleInfo={
              <div className="mt-4 d-none d-lg-block">
                <RequiredDocuments
                  fontSizeTitle="sub-body-2"
                  fontSizeContentTitle="caption"
                  fontSizeContent="caption"
                />
              </div>
            }
          />
          <div className="mt-4 d-block d-lg-none">
            <RequiredDocuments
              fontSizeTitle="body-head"
              fontSizeContentTitle="sub-body-2"
              fontSizeContent="sub-body-2"
            />
          </div>
        </div>
        <ProductWorkingCapitalSimulation />
        <ProductPartner data={partner} />
        <div className="mt-4 pt-4">
          <CheckCompany
            filters={[]}
            subtitle="Invoice kepada pengguna Pohon Dana dapat mempercepat proses pengajuan pinjaman"
            // foundMessage="Pengajuan Invoice Financing anda akan lebih mudah disetujui."
            notFoundMessage="Anda masih bisa mengajukan Invoice Financing pada Pohon Dana."
          />
        </div>

        <ProductClosingStatement
          caption="Butuh dana instan?"
          title="Ubah Invoice anda di Pohon Dana!"
          product={product}
          buttonText="Ajukan Pinjaman"
        />
      </Container>
    </div>
  );
}

export default InvoiceFinancing;
